import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import SpinnerLabel from "common/components/spinner-label";
import useConfirmationTokenPurchase from "common/stripe/use-confirmation-token-purchase";

const propTypes = {
  label: PropTypes.string,
  buttonColor: PropTypes.string,
  isProcessing: PropTypes.bool,
  submit: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired
};

const TOKEN_PARAMS = { payment_method_data: { allow_redisplay: "always" } };

const stripeModalPaymentError = message => ({ data: { base: [message] } });

const StripeModalSubmitButton = ({
  label = "Purchase",
  buttonColor = "primary",
  isProcessing = false,
  submit,
  onComplete,
  onError
}) => {
  const confirmPurchase = useConfirmationTokenPurchase();
  const [submitting, setSubmitting] = useState(false);

  const handleClick = async () => {
    setSubmitting(true);
    try {
      const response = await confirmPurchase({
        submit,
        tokenParams: TOKEN_PARAMS,
        formatError: stripeModalPaymentError
      });
      onComplete(response);
    } catch (err) {
      onError(err);
    } finally {
      setSubmitting(false);
    }
  };

  const spin = submitting || isProcessing;

  return (
    <Button
      type="button"
      disabled={spin}
      onClick={handleClick}
      color={buttonColor}
      size="lg"
      className="ml-0 btn-sharp"
    >
      <SpinnerLabel spin={spin} label={label} />
    </Button>
  );
};

StripeModalSubmitButton.propTypes = propTypes;

export default StripeModalSubmitButton;
